import { CustomTheme, OnboardingFulfilledBy } from '@nemuru-eng/js-api-client';
import { generatePath, useNavigate } from 'react-router-dom';

import { ContactInformationMap } from '@/components/modules/Application/components/ContactInformation/_shared/maps/ContactInformation.map';
import { ContactInformationFormType } from '@/components/modules/Application/components/ContactInformation/_shared/schemas/contactInformationForm.schema';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { useCreateCheckoutSession } from '@/components/modules/Application/hooks/useCreateCheckoutSession';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const useContactInformation = () => {
  const {
    state: { selectedAgent },
    actions: { updateApplicationContext },
  } = useApplicationContext();

  const navigate = useNavigate();
  const { onNext, setCompleted } = useApplicationNavigation();
  const { createCheckoutSession } = useCreateCheckoutSession();

  const submitContactInformation = async (formValues: ContactInformationFormType) => {
    const customerData = ContactInformationMap.fromFormToDto(formValues);

    updateApplicationContext({
      customerData,
      birthDate: formValues.birthDate,
      orderReference1: formValues.orderReference1,
      orderReference2: formValues.orderReference2,
    });

    if (
      selectedAgent &&
      selectedAgent.customTheme === CustomTheme.KTUIN &&
      selectedAgent.allowedOnboardingFulfilledByTypes.includes(OnboardingFulfilledBy.MERCHANT_POS)
    ) {
      try {
        const checkoutSession = await createCheckoutSession(customerData);
        if (!checkoutSession) {
          throw new Error('Checkout session not created');
        }
        setCompleted();
        navigate(
          generatePath(DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_DETAIL, {
            checkoutSessionId: checkoutSession.checkoutSessionId,
          }),
        );
      } catch (err) {
        console.error(err);
      }
      return;
    }

    onNext();
  };

  return { submitContactInformation };
};
